import apiUrl from '../../../../../constants'
import axios from 'axios'
import { Validator } from 'vee-validate'
import clientKYC from './clientKYC/index.vue';
import contracts from './contracts/contractListing/index.vue';
import otherinformation from './otherinformation/index.vue';
import ClientService from '../../../services/clientmanagement.service';
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';

export default {
 name: 'addClient',
 components: {
   'first': clientKYC,
   'second': otherinformation,
   'third': contracts,
   VueElementLoading
 },
 props: ['selectedEditRowData','productlist','statelist'],
 data() {
   return {
     companyname:'',
     clientsystemid:'',
     clientstatus:'',
     countObj:{},
     currentTab: 'First',
     componentKey:0,
     tabs: [
       { key:'First', value:'Client KYC' },
       { key:'Second', value:'Other Information' },
       { key:'Third', value:'Contracts' }
     ],
     useremail : '',
     isLoading: false,
     clientShortNameData : '',
     saveflag : false,
     clientEditDisable : false,
     clientData: this.selectedEditRowData,
     showsavebutton: true
   }
 },
 created:function() {

 },
 computed: {
   // selects all checkbox's option
   currentTabComponent: function () {
     this.componentKey += 1;
     if (this.saveflag == true) {
       this.clientShortNameData = this.companyname;
     }
     return this.currentTab.toLowerCase()
   }
 },
 mounted() {
   var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
   var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
   var plaintext = bytes.toString(CryptoJS.enc.Utf8);
   var userdetail = JSON.parse(plaintext);
   this.useremail = userdetail.email;
   if (this.selectedEditRowData != undefined) {
     this.companyname = this.selectedEditRowData.ClientShortName;
     this.clientsystemid = this.selectedEditRowData.ClientSystemID;
     this.clientstatus = (this.selectedEditRowData.IsActive == true) ? 'Active' : 'Inactive';
     this.showsavebutton = false;
     this.clientEditDisable = true;
   }else {
     this.clientShortNameData = '';
     this.companyname = '';
   }
 },
 methods: {
   showCreateServiceArea() {
     this.$emit("goBackToParent");
   },
   changeTab() {
    this.$nextTick(() => {
      this.currentTab = 'Second';
    })
  },
  goToThirdTab() {
    this.$nextTick(() => {
      this.currentTab = 'Third';
    })
 },
 createNewClient(){
     this.$validator.validateAll("clientonboardform").then((result) => {
       if(result){
         this.addClient();
       }
     }).catch(() => {
       console.log('errors exist');
       return false;
     });
  },
  async addClient() {
    try {
       this.isLoading = true;
       let payload = {
         clientShortName : this.companyname.trim(),
         createdBy : this.useremail
       }
      let result = await ClientService.getClientNameExist(payload);
      this.isLoading = false;
      if (result.data.code == 200 ) {
        this.saveflag = true;
        this.clientsystemid = result.data.data[0].ClientSystemID;
        this.companyname = result.data.data[0].ClientShortName;
        this.clientstatus = (result.data.data[0].Status == true) ? 'Active' : 'Inactive';
        this.clientData = {
          "ClientSystemID": result.data.data[0].ClientSystemID,
          "ClientShortName": result.data.data[0].ClientShortName,
          "IsActive": result.data.data[0].IsActive,
          "ClientBusinessDetailID": result.data.data[0].ClientBusinessDetailID,
          "ClientBusinessAccountId": result.data.data[0].ClientBusinessAccountId,
          "OldClientMasterId": result.data.data[0].OldClientMasterId
        };
        this.$alert(`Client data save successfully.`,this.companyname, "success");
        this.showsavebutton = false;
        this.clientEditDisable = true;
      }else{
        this.clientsystemid = '';
        this.clientstatus = '';
        //this.companyname = '';
        this.clientEditDisable = false;
        this.$alert(`Client Short Name Already Exists.`, this.companyname, "error");
      }
     } catch (e) {
       this.isLoading = false;
       this.$alert(e.message,"","error");
     }
   },
 }
}



// WEBPACK FOOTER //
// ./src/modules/clientmanagement/views/client/addclient/addclient.component.js